import React, { useState, useEffect, useCallback } from "react";
import { Select, Row, Col, Form, Icon, Spin, DatePicker, Input, InputNumber, Button, Radio, Switch } from "antd";
import { BoldOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';

import "./FormRegistro.scss";
import { Label } from "react-bootstrap";


export default function FormRegistroParticipantes(props) {
    //console.log("PROPS REGISTRO paarticipantes", props);
    const { getFieldDecorator } = props.form;
    let splited;
    const dateFormat = "DD-MM-YYYY";
    const timeFormat = "HH:mm";

    const [rangeDates, setRangeDates] = useState({
        minInicio: moment().startOf('day'),
        minFin: moment().startOf('day')
    });

    const [enabledRangeDate, setEnabledRangeDate] = useState({
        fechaInicio: false,
        fechaFin: false,
    });

    const [verificacion, setVerificacion] = useState({
        numero: 1
    });


    const [disableSwitch, setDisableSwitch] = useState(false);
    const [tipoCaptura, setTipoCaptura] = useState(-1);
    const [tipoOtro, setTipoOtro] = useState(-1);
    const [nuevaOpcion, setNuevaOpcion] = useState("");

   

    const handleGuarda = (e) => {
        e.preventDefault();
        let valAux;
        props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                //console.log('Received values of form participantes: ', values);
               if (values.grupo ==='0')
              { 
              values.grupo=tipoCaptura + "-0-" + values.otra.toUpperCase()
               props.optionsTipoGrupo.push(values.grupo)
              
                props.handleSubmit(values);
              
               }
               else
                props.handleSubmit(values);
            }
        });
    };

    const handleRangeNumber = (rule, value, callback) => {
        if (value && (value > rule.max || value < rule.min)) {
            callback(rule.message)
        }
        callback()
    }

   
    return (
        <div>

            <div>
                <Form onSubmit={handleGuarda} layout="vertical">
                    <Row>
                        <Col span={23} >
                            <label className="texto-18-adjudicacion-b">¿A quiénes se les aplicó el líquido indeleble?</label>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                    <Col span={4}>
                            <Col span={23}>
                                <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Tipo de aplicador</label>
                            </Col>
                        </Col>
                        <Col span={7}>
                            <Col span={23}>
                                <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Tipo de participante</label>
                            </Col>
                        </Col>
                        <Col span={6}>
                            <Col span={23}>
                                <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Grupo al que pertenece</label>
                            </Col>
                        </Col>
                        {tipoOtro===1 &&
                        <Col span={7}>
                            <Col span={23}>
                                <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Otro Grupo</label>
                            </Col>
                        </Col>}
                       


                    </Row>

                    <Row>
                    <Col span={4}>
                            <Col span={22}>
                                <Form.Item name="tipo" hasFeedback>
                                    {getFieldDecorator('tipo', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Seleccione un tipo de aplicador.',
                                            }
                                        ],
                                    })(
                                        <Select
                                            placeholder="Seleccione opción"
                                        >
                                            {props.optionsTipoArticulo.map((value, index) => {
                                                let splited = value.split("-")  
                                                let valor
                                                 props.opcion===3 ? valor= splited[2]:valor=splited[1]                                                 
                                                return <Select.Option key={value}>{valor}</Select.Option>;
                                            })}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>
                    
                        <Col span={7}>
                            <Col span={23}>
                                <Form.Item name="nombre" hasFeedback>
                                    {getFieldDecorator('nombre', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Seleccione un tipo de participante.',
                                            }
                                        ],
                                    })(
                                        <Select
                                            placeholder="Seleccione opción"
                                            onChange={value => {
                                                //console.log("Valores select ", value)
                                                let splited = value.split("-")
                                                setTipoCaptura(splited[0])
                                                setTipoOtro(-1)
                                                }}
                                                //tipoCaptura, setTipoCaptura 
                                        
                                        >
                                            {props.optionsTipoParticipante.map((value, index) => {
                                                  let splited = value.split("-")
                                                  return <Select.Option key={value}>{splited[1]}</Select.Option>;
                                            })}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>
                        {//console.log("tipo participante combo", tipoCaptura)
                        }
                        <Col span={6}>
                            <Col span={23}>
                                {tipoCaptura !=='3' ?
                                <Form.Item name="grupo" hasFeedback>
                                    {getFieldDecorator('grupo', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Seleccione el grupo al que pertenece el participante.',
                                            }
                                        ],
                                    })
                                    (
                                        <Select
                                            placeholder="Seleccione una opción"
                                            onSelect={value => {
                                                //console.log("Valores select2", value, "t", tipoCaptura)
                                                value==='0' ?setTipoOtro(1):
                                                setTipoOtro(-1)
                                                //let splited = value.split("-")
                                                //setTipo(splited[0])
                                                }} 
                                            disabled={tipoCaptura===-1? true:false}   
                                        >
                                            {props.optionsTipoGrupo.map((value, index) => {
                                                if(value !=='0' &&value!== null && value !== undefined )
                                               { //console.log("ENTRO PROPS OTRO", value)
                                                splited = value.split("-")
                                                if(splited[0] === tipoCaptura) 
                                                return <Select.Option key={value}>{splited[2]}</Select.Option>;
                                            }
                                            })}
                                        <Select.Option key={0}>OTRO</Select.Option>
                                        </Select>
                                    )}
                                </Form.Item>
                                :tipoCaptura ==='3' &&
                                <Form.Item name="grupo" hasFeedback>
                                {getFieldDecorator('grupo', {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Seleccione el grupo al que pertenece el participante.',
                                        }
                                    ],
                                })
                                (
                                    
                                    <Select
                                        placeholder="Seleccione una opción"
                                    >
                                        {props.optionsTipoGrupo.map((value, index) => {
                                            splited = value.split("-")
                                            if(splited[0] === tipoCaptura) 
                                            return <Select.Option key={value}>{splited[2]}</Select.Option>;
                                        })}
                                
                                    </Select>

                                )}
                            </Form.Item>

                                }
                            </Col>
                        </Col>
                         {tipoOtro===1 &&
                        <Col span={7}>
                            <Col span={23}>
                                <Form.Item name="otra" hasFeedback>
                                    {getFieldDecorator('otra', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Ingrese el nuevo grupo al que pertenece el participante.',
                                            }
                                        ],
                                    })(
                                        <Input
                                            placeholder="Ingrese el nuevo grupo"
                                            maxLength={150}
                                            onChange={v => {
                                               //console.log("valor de opcion", v.target.name,"hola" ,v.target.value.toUpperCase())
                                               v.target.value.toUpperCase()

                                            }}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>}
                        
                        
                    </Row>
                    <Row>
                    <Col span={4}>
                            <Col span={23}>
                                <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Cantidad de participantes</label>
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                    <Col span={4}>
                            <Col span={20}>
                                <Form.Item name="cantidad" hasFeedback>
                                    {getFieldDecorator('cantidad', {
                                        rules: [
                                            {
                                                type: 'integer',
                                                message: 'Cantidad de participantes no válida.',
                                            },
                                            {
                                                required: true,
                                                message: 'Ingrese la cantidad de participantes.',
                                            },
                                            {
                                                validator: handleRangeNumber,
                                                message: 'Canitdad fuera del rango permitido.',
                                                min: 1,
                                                max: 999
                                            }
                                        ],
                                    })(
                                        <InputNumber
                                            placeholder="Ingrese un número"
                                            style={{ width: '100%' }}
                                            min={1}
                                            max={999}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>
                        <Col span={3} >
                            <Col>
                                <Form.Item >
                                    <Button className="agregar" type="primary" htmlType="submit" disabled={!props.enableCaptura}>
                                        <PlusOutlined />Agregar
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Col>
                    </Row>

                    <br />
                   
                    
                </Form>
            </div>
        </div>
    )
}